module.exports = __webpack_public_path__ + "static/media/IMG_1790y.04cb5492.jpg";